var Utils = {}
const moment = require('moment');
var countries = require('country-data').countries
Utils.formatDate = function (date) {
    return moment(date).format('MMM DD, YYYY HH:mm');
}

Utils.getCountry = function (code) {
    if (!code) return "-"
    code = code.toUpperCase()
    if (countries[code] && countries[code].name) {
        return countries[code].name
    }
    return "-"
}
export {
    Utils
}